import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Link from 'components/Link';
import React from 'react';
import { Blog } from 'types';

type PodCafeCardProps = {
  podCafeContent: Blog;
};

export const PodCafeCard = ({ podCafeContent }: PodCafeCardProps) => {
  const theme = useTheme();
  const useStyles = makeStyles({
    podCafeMain: {
      padding: '170px 0px',
      [theme.breakpoints.down('sm')]: {
        padding: [[100, 0]],
        overflow: 'hidden',
        position: 'relative',
      },
      '& h4': {
        textAlign: 'center',
        fontSize: 30,
        fontWeight: 'bold',
        lineHeight: 1,
        letterSpacing: '0.3em',
        paddingBottom: '20px',
      },
      '& p': {
        fontWeight: '300',
        fontSize: '20px',
        lineHeight: '28px',
        textAlign: 'center',
        color: 'rgba(17,17,17,0.7)',
      },
    },
    root: {
      maxWidth: '340px',
      minHeight: '410px',
      borderRadius: '20px',
      cursor: 'pointer',

      '& button': {
        '&:hover': {
          '& .MuiCardActionArea-focusHighlight': {
            opacity: 0,
          },
        },
      },

      '&:hover': {
        boxShadow: '0px 2px 8px 2px rgb(189 189 189 / 20%)',
      },
    },
    media: {
      height: '177px',
      width: '100%',
      marginBottom: '15px',
      backgroundPosition: 'left center',
    },
    cafeCardsBox: {
      display: 'block',
      paddingTop: '60px',
    },
    readMore: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '20px',
      color: '#008B5E',
      marginTop: '28px',
    },
    comingSoon: {
      backgroundColor: 'rgba(242,255,251,0.98)',
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '340px',
      minHeight: '410px',
      borderRadius: '20px',
      cursor: 'pointer',

      '&:hover': {
        boxShadow: '0px 2px 8px 2px rgb(189 189 189 / 20%)',
      },

      [theme.breakpoints.down('md')]: {
        minWidth: '340px',
      },

      '& span': {
        margin: 'auto',
        fontWeight: 500,
        fontSize: '20px',
        color: '#111111',
      },
    },

    cardContent: {
      paddingTop: '8px',
      '& h5': {
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '24px',
        marginBottom: '12px',
        color: '#111111',
        height: '50px',
      },

      '& span': {
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        // wordBreak: "break-all",
        color: 'rgba(17, 17, 17, 0.7)',
        display: '-webkit-box',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
      },
    },
    cardContentInner: {
      width: 'initial !important',
      fontSize: '14px !important',
      fontWeight: 'normal !important',
      lineHeight: '20px !important',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 3,
      display: '-webkit-box',
      overflow: 'hidden    ',
    },
    cardContentBlock: {
      '& p': {
        textAlign: 'left !important',
      },
    },
  });
  const classes = useStyles();

  return (
    <Grid item lg={4}>
      <Link
        href={`/pod-cafe/${podCafeContent.slug}`}
        sx={{ textDecoration: 'none' }}
      >
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image={podCafeContent?.title_image?.url}
            />
            <CardContent
              className={`${classes.cardContent} ${classes.cardContentBlock}`}
            >
              <Typography gutterBottom variant="h5">
                {podCafeContent?.title}
              </Typography>
              <Typography
                className={`${classes.cardContent} ${classes.cardContentInner}`}
              >
                {podCafeContent?.meta_description}
              </Typography>
              <Typography component="div" className={classes.readMore}>
                Read More
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Link>
    </Grid>
  );
};
